<template>
    <base-dashboard-layout
        :menu-options="menuOptions"
        back-url="/dashboard"
    ></base-dashboard-layout>
</template>

<script>
import {
    Terminal,
    ShareSocialSharp,
    Settings,
    DocumentLock,
    DesktopOutline,
    People,
} from "@vicons/ionicons5";
import baseDashboardLayout from "./baseDashboardLayout.vue";

import { renderRouteLabel } from "../../utils/menu.js";

export default {
    name: "workspaceLayout",
    data() {
        return {
            menuOptions: [
                renderRouteLabel(
                    "/workspace/workspaceDetail/" +
                        this.$route.params.workspaceId,
                    "Details",
                    "workspaceDetail",
                    Terminal,
                ),
                renderRouteLabel(
                    "/workspace/workspaceBackup/" +
                        this.$route.params.workspaceId,
                    "Backup",
                    "workspaceBackup",
                    DocumentLock,
                ),
                renderRouteLabel(
                    "/workspace/workspaceResource/" +
                        this.$route.params.workspaceId,
                    "Resources",
                    "workspaceResource",
                    DesktopOutline,
                ),
                renderRouteLabel(
                    "/workspace/workspaceCollaborate/" +
                        this.$route.params.workspaceId,
                    "Collaborate",
                    "workspaceCollaborate",
                    People,
                ),
                renderRouteLabel(
                    "/workspace/workspaceSettings/" +
                        this.$route.params.workspaceId,
                    "Settings",
                    "workspaceSettings",
                    Settings,
                ),
            ],
        };
    },
    components: {
        baseDashboardLayout,
    },
};
</script>

<style scoped></style>
